export default __webpack_public_path__ + "static/media/stthomasApp.dae80d10.png";